import { defineStore } from "pinia"
import { Api } from "~/api/Api.ts"
import { useEntrepriseStore, useRoleStore } from "~/stores"
import { mapById, groupById } from "~/helpers"

const DEBRIEF_CATEGORIE = [
    { categorie: "Non debrief", id: 0, color: "primary" },
    { categorie: "Non entrée", id: 1, color: "red" },
    { categorie: "Non déballe", id: 2, color: "orange" },
    { categorie: "Non vendu", id: 3, color: "yellow" },
    { categorie: "Vendu", id: 4, color: "green" },
]

export const useDataCacheStore = defineStore("datacache", {
    state: () => ({
        fetched: false,
        data: {},
    }),

    getters: {
        entrepriseStore() {
            return useEntrepriseStore()
        },
        roleStore() {
            return useRoleStore()
        },
        dataCache() {
            return this.data
        },
        natureRDV() {
            return [...(this.data.NATURE_RDV || [])].sort((a, b) =>
                (a.LIBELLE || "").localeCompare(b.LIBELLE || "", "fr", {
                    sensitivity: "base",
                }),
            )
        },
        natureRdvById() {
            return mapById(this.data.NATURE_RDV, "IDNATURE_RDV")
        },
        civilite() {
            return this.data.CIVILITE
        },
        civiliteParticulier() {
            return this.data?.CIVILITE?.filter((type) => type.TYPE === "P")
        },
        origine() {
            return this.data.ORIGINE
        },
        origineById() {
            return mapById(this.data.ORIGINE, "IDORIGINE")
        },
        tva() {
            return this.data.TVA
        },
        agence() {
            return this.data.AGENCES
        },
        typeAnnulation() {
            return this.data.TYPE_ANNULATION
        },
        typeAnnulationById() {
            return mapById(this.data.TYPE_ANNULATION, "IDTYPE_ANNULATION")
        },
        typeInterventionsList() {
            return this.data.TYPE_INTERVENTION
        },
        typeInterventionById() {
            return mapById(this.data.TYPE_INTERVENTION, "IDTYPE_INTERVENTION")
        },
        bucketSize() {
            return this.data.BUCKET_SIZE
        },
        rdvDebrief() {
            if (!this.data.RDV_DEBRIEF) return []
            return DEBRIEF_CATEGORIE.map((cat) => {
                const filteredRendezvous = this.data.RDV_DEBRIEF?.filter(
                    (rdv) => rdv.TYPE_MOTIF === cat.id,
                )

                return {
                    ...cat,
                    type: filteredRendezvous,
                }
            })
        },
        rdvDebriefById() {
            if (!this.rdvDebrief) return {}
            return mapById(this.rdvDebrief, "id")
        },
        rdvDebriefTypeById() {
            if (!this.rdvDebrief) return {}
            const mergedType = this.rdvDebrief.flatMap((item) => item.type)
            return mapById(mergedType, "IDRDV_DEBRIEF")
        },
        origineCampagneById() {
            return mapById(this.data.ORIGINE_CAMPAGNE, "IDCAMPAGNE")
        },
        orgineCampagneByIdOrigine() {
            return groupById(this.data.ORIGINE_CAMPAGNE, "IDORIGINE")
        },
    },
    actions: {
        async fetchDataCache() {
            const response = await Api.dataCache.dataCacheIndex()
            this.data = response
            this.entrepriseStore.setItems(response.COMPANY, false)
            this.roleStore.setItems(response.ROLE, false)
        },
    },
})
